/**
 * Regra de obrigatoriedade do prestador na O.S.
 *
 * O prestador é opcional ao criar/editar uma O.S. (ainda pode não estar definido),
 * mas passa a ser obrigatório nas situações de execução abaixo. A mesma lista é
 * aplicada no servidor pelo gatilho `trg_service_orders_require_provider`;
 * mantenha as duas alinhadas.
 */
export const SERVICE_ORDER_PROVIDER_REQUIRED_STATUSES = [
  'scheduled',
  'in_progress',
  'awaiting_review',
  'in_correction',
  'completed',
] as const;

/** Indica se a situação informada exige prestador. */
export function statusRequiresProvider(status: string | null | undefined): boolean {
  return !!status && (SERVICE_ORDER_PROVIDER_REQUIRED_STATUSES as readonly string[]).includes(status);
}

/**
 * Formulário de O.S.: com data de início a O.S. nasce/fica Agendada, então o
 * prestador vira obrigatório; sem data, segue opcional.
 */
export function formRequiresProvider(scheduledStart: string | null | undefined): boolean {
  return !!scheduledStart && scheduledStart.trim() !== '';
}

/** Mensagem única exibida quando falta o prestador. */
export const PROVIDER_REQUIRED_MESSAGE = 'Informe o prestador de serviço antes de agendar, iniciar ou concluir a O.S.';
